module.exports = __webpack_public_path__ + "static/koushik-e0a142e7a97f5926b475d724b35467c7.png";